import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { SAVE_STOCK_CATEGORY_STOCK } from "./graphql";
import formatShipmentProductName from "./shipments/formatShipmentProductName";

const StockForm = ({
  categoryId,
  categoryName = "",
  product,
  hide,
  mode = "create",
  initialValues = {},
}) => {
  const isEditMode = mode === "edit";
  const [name, setName] = useState(
    initialValues.name !== undefined && initialValues.name !== null
      ? `${initialValues.name}`
      : product?.name || "",
  );
  const [number, setNumber] = useState(
    initialValues.number !== undefined && initialValues.number !== null
      ? `${initialValues.number}`
      : product?.number || "",
  );
  const [asin, setAsin] = useState(
    initialValues.asin !== undefined && initialValues.asin !== null
      ? `${initialValues.asin}`
      : "",
  );
  const [barcode, setBarcode] = useState(
    initialValues.barcode !== undefined && initialValues.barcode !== null
      ? `${initialValues.barcode}`
      : "",
  );
  const [unitCost, setUnitCost] = useState(
    initialValues.unitCost !== undefined && initialValues.unitCost !== null
      ? `${initialValues.unitCost}`
      : "",
  );
  const [initialQty, setInitialQty] = useState(
    initialValues.initialQty !== undefined && initialValues.initialQty !== null
      ? `${initialValues.initialQty}`
      : "0",
  );
  const [saveStock, saveStockRes] = useMutation(SAVE_STOCK_CATEGORY_STOCK, {
    onCompleted() {
      Alert(
        "success",
        isEditMode ? "Stock updated." : "Product added to warehouse.",
      );
      hide();
    },
    onError(error) {
      window.alert(parseError(error));
    },
    refetchQueries: ["FETCH_STOCK_CATEGORY"],
    awaitRefetchQueries: true,
  });

  function createHandler() {
    const parsedInitialQty = parseInt(initialQty, 10);
    if (Number.isNaN(parsedInitialQty)) {
      window.alert("Please input a valid integer for initial qty.");
      return;
    }
    if (parsedInitialQty < 0) {
      window.alert("Initial qty cannot be negative.");
      return;
    }

    const parsedUnitCost =
      unitCost === "" || unitCost === null ? null : parseFloat(unitCost);
    if (parsedUnitCost !== null && Number.isNaN(parsedUnitCost)) {
      window.alert("Please input a valid number for unit cost.");
      return;
    }

    saveStock({
      variables: {
        id: isEditMode ? initialValues.id : null,
        stockCategoryId: categoryId,
        productId: product.id,
        name: name || null,
        number: number || null,
        asin: asin || null,
        barcode: barcode || null,
        unitCost: parsedUnitCost,
        initialQty: parsedInitialQty,
      },
    });
  }

  return (
    <div>
      <div className="-mx-2">
        <table className="w-full">
          <tbody>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Product</label>
              </td>
              <td className="w-full">{formatShipmentProductName(product)}</td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Name</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Number</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>ASIN</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  value={asin}
                  onChange={(e) => setAsin(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Barcode</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  value={barcode}
                  onChange={(e) => setBarcode(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Unit Cost</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  value={unitCost}
                  onChange={(e) => setUnitCost(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="pr-4 whitespace-nowrap">
                <label>Initial Qty</label>
              </td>
              <td className="py-2">
                <Input
                  className="w-full"
                  type="number"
                  value={initialQty}
                  onChange={(e) => setInitialQty(e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-8">
        <Button onClick={createHandler} loading={saveStockRes.loading} primary>
          Save
        </Button>
      </div>
    </div>
  );
};

export default StockForm;
